import http from "./http";

/* =========================
   GET ALL USERS
========================= */
export const getUsers = async () => {
  const res = await http.post("users_api?action=get");
  return res.data;
};

/* =========================
   ✅ GET SINGLE USER (FIXED)
========================= */
export const getUserById = async (user_id) => {
  const res = await http.get("getUser", {
    params: { user_id },   // ✅ query param
  });

  return res.data;
};

/* =========================
   ADD USER
========================= */
export const addUser = async (payload) => {
  const res = await http.post("user/user_register", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

/* =========================
   UPDATE USER
========================= */
export const updateUser = async (payload) => {
  const res = await http.post("users_manage?action=update", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

/* =========================
   DELETE USER
========================= */
export const deleteUser = async (user_id) => {
  const res = await http.post(
    "users_manage?action=delete",
    { user_id },
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};


/* =========================
   DELETE MULTIPLE USERS ✅
========================= */
export const deleteMultipleUsers = async (user_ids) => {
  const res = await http.post(
    "users_manage?action=delete_multiple",
    { user_ids }, // Matches your Postman body: { "user_ids": [38, 40] }
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};